// libraries
import { useQuery } from "@tanstack/react-query";

// context
import { useLanguageContext } from "../../contexts/language.provider";
import { LANGUAGE } from "wombat-global/src/feature-flag";

// hooks
import { useFeatureFlags } from "../../hooks/useFeatureFlags";

// utility
import { translate } from "./utilities";

export const Babel: React.FC<{ children: string }> = ({ children }) => {
  const { language } = useLanguageContext();
  const { hasFlag } = useFeatureFlags();
  const shouldTranslate = language !== "en" && hasFlag(LANGUAGE);
  const {
    data: translatedText,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["translation", language, children],
    enabled: shouldTranslate,
    queryFn: () => translate(language, children),
    placeholderData: children,
    staleTime: Infinity,
    networkMode: "offlineFirst",
  });

  if (isLoading || isError) {
    return <>{children}</>;
  }

  return <>{translatedText}</>;
};
